import { render, staticRenderFns } from "./StoreSetting.vue?vue&type=template&id=2a6f7091&scoped=true"
import script from "./StoreSetting.vue?vue&type=script&lang=js"
export * from "./StoreSetting.vue?vue&type=script&lang=js"
import style0 from "./StoreSetting.vue?vue&type=style&index=0&id=2a6f7091&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f7091",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6f7091')) {
      api.createRecord('2a6f7091', component.options)
    } else {
      api.reload('2a6f7091', component.options)
    }
    module.hot.accept("./StoreSetting.vue?vue&type=template&id=2a6f7091&scoped=true", function () {
      api.rerender('2a6f7091', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/store/StoreSetting.vue"
export default component.exports